var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React, { useState, useCallback } from "react";
import IntlTelInput from "react-intl-tel-input";
import PropTypes from "prop-types";
import "react-intl-tel-input/dist/main.css";
import "./MobileNumberInput.scss";

var MobileNumberInput = function MobileNumberInput(_ref) {
  var validated = _ref.validated,
      onPhoneNumberBlur = _ref.onPhoneNumberBlur,
      onPhoneNumberChange = _ref.onPhoneNumberChange,
      inputClassName = _ref.inputClassName,
      props = _objectWithoutProperties(_ref, ["validated", "onPhoneNumberBlur", "onPhoneNumberChange", "inputClassName"]);

  var _useState = useState(false),
      isValid = _useState[0],
      setIsValid = _useState[1];

  var onChangeMobileNumberInput = useCallback(function (status, value, countryData, number) {
    if (number !== null) {
      switch (countryData.iso2) {
        case "gy":
          var guyanaMobileValidation = /^\+?(592)\)?[-. ]?(([2-7]{1})([0-9]{1})([0-9]{1}))[-. ]?([0-9]{4})$/;
          status = !!number.match(guyanaMobileValidation);
          break;
        case "tt":
          var trinidadAndTobagoMobileValidation = /^\+?(1)\)?[-. ]?(868)\)?[-. ]?(([2-7]{1})([0-9]{1})([0-9]{1}))[-. ]?([0-9]{4})$/;
          status = !!number.match(trinidadAndTobagoMobileValidation);
          break;
      }
    }
    setIsValid(status);
    if (onPhoneNumberChange) {
      var formattedNumber = number.replace(/[^0-9]/gi, "");
      onPhoneNumberChange(status, value, countryData, number, formattedNumber);
    }
  }, [onPhoneNumberChange, setIsValid]);

  var onBlurMobileNumberInput = useCallback(function (status, value, countryData, number) {
    if (number !== null) {
      switch (countryData.iso2) {
        case "gy":
          var guyanaMobileValidation = /^\+?(592)\)?[-. ]?(([2-7]{1})([0-9]{1})([0-9]{1}))[-. ]?([0-9]{4})$/;
          status = !!number.match(guyanaMobileValidation);
          break;
        case "tt":
          var trinidadAndTobagoMobileValidation = /^\+?(1)\)?[-. ]?(868)\)?[-. ]?(([2-7]{1})([0-9]{1})([0-9]{1}))[-. ]?([0-9]{4})$/;
          status = !!number.match(trinidadAndTobagoMobileValidation);
          break;
      }
    }
    setIsValid(status);
    if (onPhoneNumberBlur) {
      var formattedNumber = number.replace(/[^0-9]/gi, "");
      onPhoneNumberBlur(status, value, countryData, number, formattedNumber);
    }
  }, [onPhoneNumberBlur, setIsValid]);

  return React.createElement(IntlTelInput, _extends({
    onPhoneNumberBlur: onBlurMobileNumberInput,
    onPhoneNumberChange: onChangeMobileNumberInput,
    inputClassName: inputClassName + " " + (validated ? isValid ? "is-valid" : "is-invalid" : "")
  }, props));
};

MobileNumberInput.defaultProps = _extends({}, IntlTelInput.defaultProps, {
  containerClassName: "intl-tel-input",
  inputClassName: "form-control input-control",
  validated: false
});

MobileNumberInput.propTypes = process.env.NODE_ENV !== "production" ? _extends({}, IntlTelInput.propTypes, {

  /**
   * form validated parameter if using it in the form
   */
  validated: PropTypes.bool
}) : {};
export default MobileNumberInput;